import type { DocumentationTabTypes } from '../../types/enums/DocumentationTabTypes';
import type { PanelType } from '../panels/types';
import type { ConfigurationTypesWithIcon } from './salesforce-documentation-card/types';
import { AutomationType } from '../../types/enums/AutomationType';
import type { ROLLUP } from '../parser/ConfigurationItemTypes';
import {
  SWEEP_AUTOMATION,
  SWEEP_ASSIGNMENT,
  SWEEP_SCHEDULED_ASSIGNMENT,
  SWEEP_ALERT,
  SWEEP_MATCHING,
  SWEEP_DEDUPE,
} from '../parser/ConfigurationItemTypes';

export type AutomationStructureWithParentType = AutomationStructureNew & {
  parentType: string;
};

export const documentationPanelType: PanelType = {
  name: 'documentation',
  location: 'left',
};

export type SweepElementTypes =
  | typeof SWEEP_AUTOMATION
  | typeof SWEEP_ASSIGNMENT
  | typeof SWEEP_SCHEDULED_ASSIGNMENT
  | typeof SWEEP_ALERT
  | typeof SWEEP_MATCHING
  | typeof SWEEP_DEDUPE
  | typeof ROLLUP;

export const automationTypeToSweepElementType = (
  automationType: AutomationType,
): ConfigurationTypesWithIcon => {
  switch (automationType) {
    case AutomationType.Default:
      return SWEEP_AUTOMATION;
    case AutomationType.Assignment:
      return SWEEP_ASSIGNMENT;
    case AutomationType.ScheduledAssignment:
      return SWEEP_SCHEDULED_ASSIGNMENT;
    case AutomationType.Alert:
      return SWEEP_ALERT;
    case AutomationType.Dedupe:
      return SWEEP_DEDUPE;
    case AutomationType.Matching:
      return SWEEP_MATCHING;
    default:
      return SWEEP_AUTOMATION;
  }
};

export type SelectedObjectListElements = {
  value: string;
  label: string;
  badgeLabel?: number;
}[];

export type RecordTypesLabelsAndStepsByNameAndObjectName = {
  [objectName: string]: {
    [rtName: string]: {
      label: string;
      leadingFieldName: string;
      steps: { value: string; label: string }[];
    };
  };
};

export interface ObjectWithPills extends ObjectTypeName {
  pills?: {
    [key in DocumentationTabTypes]: number;
  };
}

export enum SubPageTypes {
  objects = 'objects',
  tags = 'tags',
  users = 'users',
}

export enum DocumentationPageType {
  metadataTypes = 'metadataTypes',
  tagsAndUsers = 'tagsAndUsers',
  universalSearch = 'universalSearch',
}
